import { PathOptions } from "leaflet";

export const ute_fossil_base_existente = (feature: any): PathOptions => {
  return {
    color: "#696969",
    weight: 2,
    opacity: 1,
    fillColor: "#808080",
    fillOpacity: 0.6,
  };
};
